import type { CategoryPublicDescription as Description } from '@/lib/categories/category-description-selection'
import styles from './category-public-description.module.scss'
import { Lightbulb } from 'lucide-react'

export default function CategoryPublicDescription({
  description,
  quickTip,
}: {
  description?: Description
  quickTip?: string
}) {
  if (!description && !quickTip) return null
  return (
    <section
      className={styles.description}
      aria-label={description ? `About ${description.name}` : 'Category quick tip'}
    >
      {description && (
        <>
          <h2>{description.name}</h2>
          <div dangerouslySetInnerHTML={{ __html: description.description }} />
        </>
      )}
      {quickTip && (
        <aside className={styles.quickTip} aria-label="Quick tip">
          <span className={styles.tipLabel}>
            <Lightbulb size={14} aria-hidden="true" /> Quick tip
          </span>
          <div dangerouslySetInnerHTML={{ __html: quickTip }} />
        </aside>
      )}
    </section>
  )
}
